import { useEffect, useState } from 'react';
import type { UserAddress } from '@/lib/supabase/userAddresses';
import type { NoteLocation } from '@/types/location';

const GUEST_ADDRESS_KEY = 'guest_selected_address';

export interface GuestAddressData {
  id?: string;
  label?: string;
  location: NoteLocation;
  is_primary?: boolean;
  floor?: string | null;
  apartment?: string | null;
  notes?: string | null;
  altura?: string | null;
  streetName?: string | null;
  salutation?: string | null;
  firstName?: string | null;
  lastName?: string | null;
}

export const useGuestAddress = () => {
  const [guestAddress, setGuestAddress] = useState<GuestAddressData | null>(null);

  // Load from localStorage on mount
  useEffect(() => {
    const stored = localStorage.getItem(GUEST_ADDRESS_KEY);
    if (stored) {
      try {
        setGuestAddress(JSON.parse(stored));
      } catch (e) {
        console.error('Failed to parse guest address from localStorage', e);
      }
    }
  }, []);

  const saveGuestAddress = (address: GuestAddressData) => {
    localStorage.setItem(GUEST_ADDRESS_KEY, JSON.stringify(address));
    setGuestAddress(address);
  };

  const clearGuestAddress = () => {
    localStorage.removeItem(GUEST_ADDRESS_KEY);
    setGuestAddress(null);
  };

  const getGuestAddress = () => guestAddress;

  return {
    guestAddress,
    saveGuestAddress,
    clearGuestAddress,
    getGuestAddress,
  };
};

export const getStoredGuestAddress = (): GuestAddressData | null => {
  const stored = localStorage.getItem(GUEST_ADDRESS_KEY);
  if (stored) {
    try {
      return JSON.parse(stored);
    } catch (e) {
      console.error('Failed to parse guest address from localStorage', e);
    }
  }
  return null;
};

export const saveGuestAddressToStorage = (address: GuestAddressData) => {
  localStorage.setItem(GUEST_ADDRESS_KEY, JSON.stringify(address));
};

export const clearGuestAddressFromStorage = () => {
  localStorage.removeItem(GUEST_ADDRESS_KEY);
};
